export const currentFeaturesList = [
  'All workspace members',
  'Batch payments',
  'Combined payments',
  'Vendor W-9 and 1099 reporting',
  'Lower transactions fee',
];
